import { serverInfo } from "../config/serverConfig";
import { checkResponse } from "../utils/apiError";


import { apiFetch } from "./apiFetch";

/**
 * Bulk update one or more fields across many transactions.
 * Body: { account_id, _ids, category?, taxCategory?, assetId? }
 * Returns { matched, modified }.
 */
export async function bulkUpdateTransactions(payload) {
  const resp = await apiFetch(serverInfo.serverUrl + "/bulkUpdateTransactions", {
    method: "POST",
    body: JSON.stringify(payload),
  });
  checkResponse(resp);
  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(text || "Bulk update failed");
  }
  return resp.json();
}

/**
 * Split a single transaction into 2 rows, preserving the total.
 * Body: { account_id, _id, splitAmount, splitName }
 * - splitAmount is the positive magnitude to split (server applies original sign)
 */
export async function splitTransaction(payload) {
  const resp = await apiFetch(serverInfo.serverUrl + "/splitTransaction", {
    method: "POST",
    body: JSON.stringify(payload),
  });
  checkResponse(resp);
  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(text || "Split transaction failed");
  }
  return resp.json();
}

